import { render, staticRenderFns } from "./my-account-btn.vue?vue&type=template&id=8ee6dda8&scoped=true&"
import script from "./my-account-btn.vue?vue&type=script&lang=js&"
export * from "./my-account-btn.vue?vue&type=script&lang=js&"
import style0 from "./my-account-btn.vue?vue&type=style&index=0&id=8ee6dda8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee6dda8",
  null
  
)

export default component.exports